import * as React from 'react';
import { observer, inject } from 'mobx-react';
import LoggedinUser from '../../models/LoggedinUser';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import { getNoBrand } from 'src';


// css
const initiateformstyle = require('./initiateform.css');

// Props
interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class PasswordForm extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  handleLoginNameChange = e => this.props.loggedinUser.properties.setLoginName(e.target.value);
  handlePasswordChange = e => this.props.loggedinUser.properties.setPassword(e.target.value);
  handleSubmitForm = (e) => {
    e.preventDefault();
    this.props.loggedinUser.login('initiatelogin');
    return false;
  }

  render() {

    const noBrand = getNoBrand();
    const branding = noBrand ? ('nobrand') : (this.props.loggedinUser.branding.brandingName);
  
    let buttonClass;
    if (branding ==='tellit'){
      buttonClass = "LogIn_button_tellit";
    } else {
      buttonClass = "LogIn_button";
    }
    
    return (
      <div>
        {/* <div className="initiateForm_title">Logga in med kod</div> */}
        <form onSubmit={this.handleSubmitForm} className="login_username_box">
          <fieldset>
            <fieldset className="form-group">
              <input
                className="form-control form-control-lg"
                type="text"
                placeholder="Mobilnummer/Email"
                value={this.props.loggedinUser.properties.loginname}
                onChange={this.handleLoginNameChange}
              />
            </fieldset>

            <h6 className="passWordError">{this.props.loggedinUser.properties.errors}</h6>

            <Button
              variant="raised"
              className={buttonClass}
              type="submit"
              disabled={false}
              fullWidth={true}
            >
              Skicka kod
            </Button>

          </fieldset>
        </form>
        <div className="login_forgotPassword_surf_box">
          <a

            href={`/login`}
            onClick={e => {
              e.preventDefault();
              this.props.loggedinUser.view.setLoginForm('passwordlogin');
              return false;
            }}
          >
            <div className="logInPasswordLink">
              Logga in med lösenord
            </div>
          </a>
        </div>
      </div>
    );
  }
}  


// WEBPACK FOOTER //
// ./src/components/loginforms/InitiateForm.tsx